import React, { useState } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import feature1 from "../../assets/images/compire-left.png";
import feature2 from "../../assets/images/feature-2.png";
import feature3 from "../../assets/images/compire-right.png";
import feature4 from "../../assets/images/feature-4.png";
import google from "../../assets/images/google-logo.svg";
import { IoStarSharp } from "react-icons/io5";
import { GoDash } from "react-icons/go";

import { Button } from "antd";
import {
  MdOutlineArrowForwardIos,
  MdOutlineArrowBackIos,
} from "react-icons/md";
import styled from "styled-components";
import { green } from "../../constants/colors";
import CustomRating from "../../components/rating";
import CustomModal from "../customModal";
import CompareCarDetail from "./compareCarDetail";

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
    slidesToSlide: 3,
  },
  tablet: {
    breakpoint: { max: 1024, min: 768 },
    items: 2,
    slidesToSlide: 1,
  },
  mobile: {
    breakpoint: { max: 767, min: 300 },
    items: 1,
    slidesToSlide: 1,
  },
};

const sliderItems = [
  {
    image: feature1,
    alt: "feature 1",
    text: "Great Services!",
    description: `"Drvico-Agency to the actively encourage customers to leave reviews to the help promote their products and services."`,
    name: "Nowry Jahan",
  },
  {
    // image: feature2,
    alt: "feature 2",
    text: "Compare Cars, Choose Wisely",
    description: `Easily compare cars to find the one that suits your needs,
            preferences, and budget. Check specifications, features, and pricing
            all in one place.`,
    name: "John Abraham",
  },
  {
    image: feature3,
    alt: "feature 3",
    text: "Trusted Company",
    description: `"Drvico-Agency cutomer feedback is an invauable source of information that can help businesses improve their offerings and provide better experiences."`,
    name: "John Abraham",
  },
];

const CustomButtonGroupContainer = styled.div`
  position: absolute;
  bottom: 10px !important;
  right: 0;
  left: 0;
  //   transform: translateX(-50%);
  display: flex;
  justify-content: space-between;
  gap: 20px;
  width: 60%;
  margin: 0 auto;
  padding: 0 9px;

  @media (max-width: 768px) {
    bottom: -55px !important;
  }
`;

const CustomButton = styled(Button)`
  background-color: transparent;
  border-radius: 100%;
  height: 35px;
  width: 35px;
  font-size: 18px;
  text-align: center;
  color: lightgray !important;
  padding: 5px !important;
  color: #333;
  transition: all 0.3s ease-in-out;
  border-color: ${green} !important;

  &:hover {
    background-color: ${green} !important;
    border-color: ${green} !important;
    color: white !important;

    svg {
      color: white !important;
    }
  }
`;

const CustomButtonGroup = ({ next, previous }) => {
  return (
    <CustomButtonGroupContainer className="custom-button-group">
      <CustomButton onClick={previous} className="custom-prev-button">
        <MdOutlineArrowBackIos style={{ color: green }} />
      </CustomButton>

      <CustomButton onClick={next} className="custom-next-button">
        <MdOutlineArrowForwardIos style={{ color: green }} />
      </CustomButton>
    </CustomButtonGroupContainer>
  );
};

const SlideContainer = styled.div`
  overflow: hidden;
  width: 100%;
  //   margin-top: 80px;
  display: flex;
  justify-content: center;
  //   :hover & {
  //     cursor: pointer;
  //   }
`;

const SlideContent = styled.div`
  padding: 6px 0;
  width: 99% !important;
  min-height: 500px;
  padding: 50px 30px;
  margin: 0 auto;
  background: transparent;
  border: none;
  transition: transform 0s ease-in-out;
  //   ${SlideContainer}:hover & {
  //     border: 1px solid ${green};
  //     cursor: context-menu;
  //   }
  @media (max-width: 768px) {
    width: 100% !important;
    padding: 20px 0px !important;
  }
`;

const CompareCarSlider = () => {
  const [openModal, setOpenModal] = useState(false);
  return (
    <>
      <CustomModal
        title="Comparison"
        openModal={openModal}
        setOpenModal={setOpenModal}
        comparison="true"
      >
        <CompareCarDetail setOpenModal={setOpenModal} />
        {/* <CustomForm setOpenModal={setOpenModal} /> */}
      </CustomModal>
      <div className="parent" style={{ position: "relative" }}>
        <Carousel
          responsive={responsive}
          autoPlay={true}
          swipeable={true}
          draggable={true}
          showDots={false}
          infinite={true}
          partialVisible={false}
          customButtonGroup={<CustomButtonGroup />}
          renderButtonGroupOutside={true}
          arrows={false} // Hide the default arrows
        >
          {sliderItems.map((item, index) => (
            <SlideContainer key={index}>
              <SlideContent>
                <div className="flex justify-between items-center">
                  <div className="flex justify-between items-center">
                    {/* {index === 0 ? ( */}
                      <img
                        className="mt-28 hidden md:flex "
                        src={item?.image}
                        alt=""
                      />
                    {/* ) : index === 1 ? ( */}
                      <div className="text-center">
                        <div className="text-center text-[white] mb-8">
                          <p className="text-[16px] md:text-[34px] font-[700] mb-2 mt-4">
                            {item?.text}
                          </p>
                          <p className="text-[16px] md:text-[18px] mb-2 mt-4">
                            {item.description}
                          </p>
                        </div>
                        <div className="flex justify-center items-center gap-6 text-[white] mb-6 ">
                          <div className="text-right">
                            <p className="text-[16px] md:text-[18px] font-[500] mb-2 tracking-wide">
                              (Mercedes)
                            </p>
                            <div className="w-[170px] m-auto">
                              <p className="font-[600] text-[24px] tracking-wide">
                                Nissan Altima S-2023
                              </p>
                              <p className="text-[20px] text-customGreen font-[500] mt-3">
                                $90,319.000
                              </p>
                            </div>
                          </div>
                          <div
                            className="h-[106px] bg-customGreen w-[6px]"
                            style={{
                              clipPath:
                                "polygon(0 0, 100% 10%, 100% 100%, 0 90%)",
                            }}
                          ></div>
                          <div className="text-left">
                            <p className="text-[16px] md:text-[18px] font-[500] mb-2 tracking-wide">
                              (BMW)
                            </p>
                            <div className="w-[170px] m-auto">
                              <p className="font-[600] text-[24px] tracking-wide">
                                Chevrolet Silverado
                              </p>
                              <p className="text-[20px] text-customGreen font-[500] mt-3">
                                $93,740.000
                              </p>
                            </div>
                          </div>
                        </div>
                        <button
                          onClick={() => setOpenModal(true)}
                          className="bg-customGreen py-3 px-5 rounded rounded-4"
                        >
                          Comparing Cars
                        </button>
                      </div>
                    {/* ) : ( */}
                      <img
                        className="mt-28 hidden md:flex"
                        src={item?.image}
                        alt=""
                      />
                    {/* )} */}
                  </div>
                </div>
              </SlideContent>
            </SlideContainer>
          ))}
        </Carousel>
      </div>
    </>
  );
};

export default CompareCarSlider;
